import React, { useState, useEffect } from 'react';

async function fetchNotifications(token) {
  return fetch(process.env.REACT_APP_API_URL + '/app/notifications', {
    headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
  }).then(r => r.json()).catch(() => ({ notifications: [] }));
}

async function dismissNotification(token, id) {
  return fetch(process.env.REACT_APP_API_URL + '/app/notifications/' + id + '/seen', {
    method: 'POST',
    headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
  }).catch(() => {});
}

const TYPE_LABEL = {
  no_data_received: 'No Data Received',
  no_request_sent: 'No Request Sent',
};

const TYPE_COLOR = {
  no_data_received: '#e74c3c',
  no_request_sent: '#e67e22',
};

export default function Notifications({ token }) {
  const [notifications, setNotifications] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!token) return;
    fetchNotifications(token).then(data => {
      setNotifications(data.notifications || []);
    });
  }, [token]);

  const dismiss = async (id) => {
    await dismissNotification(token, id);
    setNotifications(prev => prev.filter(n => n.id !== id));
  };

  const count = notifications.length;

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          background: 'none', border: 'none', cursor: 'pointer',
          padding: '0 8px', position: 'relative', color: '#fff'
        }}
        title="Notifications"
      >
        <span uk-icon="bell" style={{ fontSize: 20 }}></span>
        {count > 0 && (
          <span style={{
            position: 'absolute', top: -6, right: 0,
            background: '#e74c3c', color: '#fff',
            borderRadius: '50%', width: 18, height: 18,
            fontSize: 11, fontWeight: 'bold',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            {count > 99 ? '99+' : count}
          </span>
        )}
      </button>

      {open && (
        <div style={{
          position: 'absolute', right: 0, top: '110%',
          width: 380, maxHeight: 480, overflowY: 'auto',
          background: '#fff', border: '1px solid #ddd',
          borderRadius: 6, boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
          zIndex: 9999,
        }}>
          <div style={{ padding: '10px 14px', borderBottom: '1px solid #eee', fontWeight: 600, fontSize: 14 }}>
            Alerts ({count})
          </div>
          {count === 0 ? (
            <div style={{ padding: 20, color: '#888', textAlign: 'center', fontSize: 13 }}>
              No active alerts
            </div>
          ) : (
            notifications.map(n => (
              <div key={n.id} style={{
                padding: '10px 14px', borderBottom: '1px solid #f0f0f0',
                display: 'flex', alignItems: 'flex-start', gap: 10,
              }}>
                <div style={{ flex: 1 }}>
                  <div style={{
                    fontSize: 11, fontWeight: 600, color: TYPE_COLOR[n.type] || '#555',
                    marginBottom: 3, textTransform: 'uppercase'
                  }}>
                    {TYPE_LABEL[n.type] || n.type}
                  </div>
                  <div style={{ fontSize: 13, color: '#333', lineHeight: 1.4 }}>{n.message}</div>
                  <div style={{ fontSize: 11, color: '#aaa', marginTop: 4 }}>
                    {new Date(n.created_at).toLocaleDateString()}
                  </div>
                </div>
                <button
                  onClick={() => dismiss(n.id)}
                  style={{
                    background: 'none', border: 'none', cursor: 'pointer',
                    color: '#aaa', fontSize: 16, padding: 0, lineHeight: 1,
                    flexShrink: 0,
                  }}
                  title="Dismiss"
                >
                  ✕
                </button>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}
